/** ES5 doesn't support extending from Error, so we'll make our own version of Error to include the stack in all our exceptions */

export class Exception {
  message: string;
  stack: string;
  originalException: unknown;
  constructor(message?: string, originalException?: unknown) {
    this.message = message;
    this.originalException = originalException;
    this.stack = new Error().stack;
    // unwrap Error because otherwise it will not be converted to JSON, because Errors can't be stringified
    if (this.originalException instanceof Error) {
      this.originalException = {
        name: this.originalException.name,
        message: this.originalException.message,
        stack: this.originalException.stack,
      };
    }
  }
}
